import { useState } from 'react'

interface PasswordFieldProps {
  id: string
  name?: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  autoComplete?: string
}

/**
 * The prototype's `.au-pw` show/hide password control (login.html + signup.html).
 *
 * The eye glyph is the inline SVG from the prototype, kept verbatim: the `.au-pw__slash`
 * path is revealed by the `.au-pw.is-shown` CSS rule rather than by swapping icons, so the
 * only thing React has to do is toggle the wrapper class and the input type.
 */
export function PasswordField({
  id,
  name,
  value,
  onChange,
  placeholder,
  autoComplete,
}: PasswordFieldProps) {
  const [shown, setShown] = useState(false)

  return (
    <div className={shown ? 'au-pw is-shown' : 'au-pw'}>
      <input
        className="au-input"
        id={id}
        name={name ?? id}
        type={shown ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
      <button
        className="au-pw__btn"
        type="button"
        aria-label={shown ? 'Hide password' : 'Show password'}
        onClick={() => setShown((v) => !v)}
      >
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z"></path>
          <circle cx="12" cy="12" r="3"></circle>
          <path className="au-pw__slash" d="M4 20 20 4"></path>
        </svg>
      </button>
    </div>
  )
}

export default PasswordField
